import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
// import axios from '../../Axios'
// import { Urls } from '../../Urls'
import classes from '../DhandhaNow/DhandaNowFunc.module.css'
import { useAppContext } from '../../Context/AppContext';
// import { toast } from 'react-toastify'
// import { Constants} from '../../Constants'
// function updateUserPolicy(txn_id, policy_type) {
//     var data = {
//         // "service_name": 'dhandanow',
//         "update_policy": {
//             "lane_count": Constants.dhandanow[policy_type]['lane_count'],
//             "access_type": Constants.dhandanow[policy_type]['access_type']
//         },
//         "transaction": {
//             "txn_id": txn_id,
//             "timestamp": (Date(24 * 3600 * 1000))
//         }
//     }


const ModalUpgrade1 = ({ groupPolicy1, show = false, isLand = false, showpopup=1, setshowpopup }) => {
    const history = useHistory();
    // const [groupPolicy, setgroupPolicy] = useState([])
    // const [loading, setloading] = useState(false)
    // const [show1, setshow1] = useState(false)

    useEffect(() => {
        // setgroupPolicy(groupPolicy1)
        // setshow1(show)
        // setloading(false)
        // axios.get(Urls.Transporter.Get)
        //     .then(res => {
        //         // if (res.data.policy && res.data.policy['dhandhanow']) {
        //         //     setsearchHistory(res.data.policy['dhandhanow']['history'] ? res.data.policy['dhandhanow']['history'] : [])
        //         //     setlaneCount(res.data.policy['dhandhanow']['allowed_lanes'])
        //         //     // setlaneCount(0)
        //         //     setUserPolicy(res.data.policy['dhandhanow'])
        //         //     setpolicyType(res.data.policy['type'])
        //         // }
        //         getUserGroupDetails(res.data['policy']['group'])
        //         setloading(true)
        //         // getExpressionOfInterest()
        //         // if(laneCount < 1){
        //         //     document.getElementById('upgrademodal').style.display = 'block'
        //         // }
        //     })
    }, [])

    // const getAllowedLanes = (policyType = 'standard') => {
    //     let groupPolicyLength = groupPolicy.length
    //     for (let i = 0; i < groupPolicyLength; i++) {
    //         if (groupPolicy[i]['type'] === policyType) {
    //             return groupPolicy[i]['dhandhanow']['allowed_lanes']
    //         }
    //     }
    // }
    // const getAmount = (policyType = 'standard', amountType = 'final_amount', isPayment = true) => {
    //     let groupPolicyLength = groupPolicy.length
    //     for (let i = 0; i < groupPolicyLength; i++) {
    //         if (groupPolicy[i]['type'] === policyType) {
    //             return `${groupPolicy[i][amountType]}`.toString()
    //         }
    //     }
    // }


    const UpgradeModal = () => {
        return (
            <div className={classes['upgrade-modal']} >
                {/* <h3 className="text-center s-hi"><span>Congratulations! {localStorage.getItem("transporter_name")}</span></h3>
                <center>
                    <span className={classes['s-you']} style={{ fontSize: '16px', fontWeight: '100', marginLeft: '2%' }}>You have been shortlisted for LoRRI Membership! </span> <br />
                    <span style={{ fontSize: '16px', fontWeight: '100', marginLeft: '19px' }}><b>  LoRRI </b> helps you find <b style={{fontWeight: 'bold'}}>New Business / Tenders, Align Return Loads</b> from <b style={{fontWeight: 'bold'}}>100+ Companies.</b> <button style={{ fontSize: '17px', cursor: 'pointer', backgroundColor: 'white',border:'none', color:'#393186', borderColor:'white', outline:'none' }} target="_blank" onClick={LaneIntelligence}><b></b></button></span>                
                </center>
                  
                <div className={`row ${classes['s-ca']} ${classes['s-carow']}`}>
                    <div className="col-sm-6">
                        <div className="pyro" >
                            <div className="before"></div>
                            <div className="after"></div>
                        </div>
                        <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`}>
                            <h6 className="card-text text-center"><b>Standard</b></h6>
                            <h6 className={`card-text ${classes['s-standard']}`}><b> {getAllowedLanes('standard')} lane searches</b></h6>
                            <span className={`card-text ${classes['s-size']}`}>₹ {getAmount("standard", "display_amount", false)}<span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>

                            <button
                                type="button"
                                className={`btn  ${classes['s-wi']}`}
                                onClick={openStandardCheckout}>
                                Subscribe Now
                            </button>
                        </div>
                    </div>
                    <div className="col-sm-6" style={{ marginLeft: '-6%' }}>
                        <div className={`card ${classes['dhandhanow']} ${classes['s-u-dhandhanow']}`}>
                            <h6 className="card-text text-center"><b>Premium</b></h6>
                            <h6 className={`card-text ${classes['s-standard']}`}><b> {getAllowedLanes('premium')} lane searches</b></h6>
                            <span className={`card-text ${classes['s-size']}`}>₹ {getAmount('premium', 'display_amount', false)} <span className={classes['gst-text']}> + Taxes (18% GST) </span> </span>
                            <button
                                type="button"
                                className={`btn  ${classes['s-wi']}`}
                                onClick={openPremiumCheckout}>
                                Subscribe Now
                            </button>
                        </div>
                    </div>
                </div>

                <div className={`col-12 ${classes['s-des']}`}>
                    <span className={`${classes['s-dess']}`} style={{fontWeight: '100', marginLeft: '7%'}}>
                        For more information contact us at <b style={{fontWeight: 'bold'}}>+91-9867773519</b> or mail us at <u style={{color:'#393186' }}>lorri@logisticsnow.in</u>
                    </span>
                </div> */}
            </div>
        )
    }

    const redirect = () => {
        history.push({ pathname: '/expression-of-interest' })
        document.getElementById('subscribe_pop_up1').style.display = 'none';
        localStorage.setItem("hasPopupBeenShown", 1); // Mark popup as shown
        show = false;
        setshowpopup(1)
    }
    const {transporterInfo} = useAppContext()

    const UpgradeModal1 = () => {
        return (
            // <div className={classes['upgrade-modal']} >
            //     <br />
            //     <h3 className="text-center s-hi"><span style={{fontSize: '25px'}}>Upgrade Now</span></h3>
            //     <hr/><br />
            //     <center>    
            //         <span className={classes['s-you']} style={{ fontSize: '35px', fontWeight: 'bold'}}>
            //             Hello {localStorage.getItem("transporter_name")}! 
            //         </span> 
            //     </center><br />
            //     <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '7%' }}>
            //         To find out how you can get guaranteed business, please drop us an email on
            //     </span><br/>
            //     <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '20%' }}>
            //         lorri@logisticsnow.in or call us on  +91-9867773519.
            //     </span>
            // </div>
            <div className={classes['upgrade-modal']} >
                <br />
                <h3 className="text-center s-hi"><span style={{fontSize: '25px'}}>Upcoming Business Opportunity</span></h3>
                <hr/><br />
                <center>    
                    <span className={classes['s-you']} style={{ fontSize: '35px', fontWeight: 'bold'}}>
                        Hello {transporterInfo?.transporter_name},
                    </span> 
                </center><br />
                <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '20%' }}>
                    Express you Interest for Upcoming Business in LoRRI
                </span><br/><br/><br/>
                <span style={{ fontSize: '20px', fontWeight: '100', marginLeft: '40%' }}>
                    <button className='btn btn-sm btn-primary' onClick={redirect}>Express Business Now!</button>
                </span>
            </div>
        )
    }

    const closeUpgradeModal = () => {
        document.getElementById('subscribe_pop_up').style.display = 'none'
        show = false
    }

    // const closeUpgradeModal1 = () => {
    //     document.getElementById('subscribe_pop_up1').style.display = 'none'
    //     show = false
    // }

    const closeUpgradeModal1 = () => {
        document.getElementById('subscribe_pop_up1').style.display = 'none';
        localStorage.setItem("hasPopupBeenShown", 1); // Mark popup as shown
        show = false;
        setshowpopup(1)
    }

    return (
        <>
            {show ?
                <>
                {showpopup !== 1? <div style={{ display: 'block', zIndex: '50000',  height: '50%', boxShadow: 'inset 0 0 10px', borderRadius: '15px' }} className={classes['upgrademodal']} id="upgrademodal">
                    <i onClick={closeUpgradeModal1} className={` fa fa-window-close ${classes['s-upgrade-div']}`}></i>
                    <UpgradeModal1 />
                </div>: null}
                </>
                :
                <div style={{ display: 'block', zIndex: '50000', marginLeft: '15%', height: '60%', boxShadow: 'inset 0 0 10px', borderRadius: '15px' }} className={classes['upgrademodal']} id="upgrademodal">
                    <i onClick={closeUpgradeModal} className={` fa fa-window-close ${classes['s-upgrade-div']}`}></i>
                    <UpgradeModal />
                </div>
            }
        </>
    )
}

export default ModalUpgrade1
